import React from "react";

const GngCodeIcon = ({ color = "#6D7885", ...rest }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="1.6"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    focusable="false"
    {...rest}
  >
    <circle cx="9" cy="9" r="6" />
    <path d="M3 9h12M9 3c3 3 3 9 0 12-3-3-3-9 0-12Z" />
    <path d="m14 16-2 2 2 2m6-4 2 2-2 2m-2-5-2 6" />
  </svg>
);

export default GngCodeIcon;
